/**
 * Merkezî Ciftora marka katmanı. Logo yolları burada tanımlıdır; bileşenler hard-code etmez.
 * Admin panelinden değiştirilirse /api/brand üzerinden geçersiz kılınır.
 */
import { useEffect, useState } from "react";
import { api, cachedGet } from "@/lib/api";

const ROOT = "/brand/ciftora";

export const BRAND = {
  brandName: "CIFTORA",
  slogan: "Çiftliğin Dijital Dünyası",
  secondarySlogan: "Tarım ve Hayvancılığın Dijital Platformu",
  productMessage: "Hayvanını bul, çiftliğini yönet, verini analiz et, geleceğini planla.",
  domain: "ciftora.com",
  altText: "Ciftora – Çiftliğin Dijital Dünyası",
  primaryLogo: `${ROOT}/logo/ciftora-logo-primary.png`,
  transparentLogo: `${ROOT}/logo/ciftora-logo-transparent.png`,
  headerLogo: `${ROOT}/logo/ciftora-logo-header.png`,
  horizontalLogo: `${ROOT}/logo/ciftora-logo-horizontal.png`,
  whiteLogo: `${ROOT}/logo/ciftora-logo-white.png`,
  documentLogo: `${ROOT}/documents/ciftora-logo-document.png`,
  symbol: `${ROOT}/symbol/ciftora-symbol.png`,
  favicon: `${ROOT}/favicon/favicon-32.png`,
  watermark: `${ROOT}/watermark/ciftora-watermark.png`,
  ogImage: `${ROOT}/social/ciftora-og-default.webp`,
};

let cache = null;

export function useBrand() {
  const [brand, setBrand] = useState(cache || BRAND);
  useEffect(() => {
    if (cache) return;
    cachedGet("/brand")
      .then((data) => {
        cache = { ...BRAND, ...data };
        setBrand(cache);
      })
      .catch(() => {});
  }, []);
  return brand;
}

/** Ciftora logosu. Oranı korur, hiçbir yerde sıkıştırılmaz veya döndürülmez. */
export const CiftoraLogo = ({ variant = "header", className = "", testid = "ciftora-logo" }) => {
  const brand = useBrand();
  const src =
    variant === "symbol" ? brand.symbol
    : variant === "white" ? brand.whiteLogo
    : variant === "primary" ? brand.primaryLogo
    : brand.headerLogo;
  return (
    <img
      src={src}
      alt={brand.altText || BRAND.altText}
      data-testid={testid}
      className={`w-auto max-w-full shrink-0 object-contain ${className}`}
      loading="eager"
      decoding="async"
    />
  );
};
